import './CoralCTA.scss'

import { CTA } from '@websrc/App/Components/CTA'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapCoralWebCTA } from '@websrc/DataMappers/mapSpot'
import React from 'react'

type CoralCTAProps = ReturnType<typeof mapCoralWebCTA>

export const CoralCTA = ({ cta, headline, description, background_color }: CoralCTAProps) => {
  if (!cta) return null

  const bgColorModifierClass = background_color
    ? `m--bg-color-${background_color.toLocaleLowerCase()}`
    : 'm--bg-color-coral'

  return (
    <div className={'container-coral-spot'}>
      <div className={`coral-cta ${bgColorModifierClass}`}>
        {headline && <h2 className={'coral-cta__headline'}>{headline}</h2>}
        {description && <div className={'coral-cta__description'}>{description}</div>}
        {cta && (
          <CTA
            className={'coral-cta__cta'}
            cta={cta}
            onClick={() => {
              matomo.trackEvent('engagement', 'all', ['coral cta spot'], [cta?.text], 'button')
            }}
          />
        )}
      </div>
    </div>
  )
}
